import axios from 'axios'

const ContactsService = {
  // list (Laravel paginate)
  async list(params = {}) {
    return axios.get('contacts', { params })
  },

  async get(id, params = {}) {
    return axios.get(`contacts/${id}`, { params })
  },

  async create(payload = {}) {
    return axios.post('contacts', payload)
  },

  async update(id, payload = {}) {
    return axios.put(`contacts/${id}`, payload)
  },

  async destroy(id) {
    return axios.delete(`contacts/${id}`)
  },

  // notes
  async listNotes(contactId, params = {}) {
    return axios.get(`contacts/${contactId}/notes`, { params })
  },

  async addNote(contactId, payload = {}) {
    return axios.post(`contacts/${contactId}/notes`, payload)
  },

  async deleteNote(contactId, noteId) {
    return axios.delete(`contacts/${contactId}/notes/${noteId}`)
  }
}

export default ContactsService
